module.exports = __webpack_public_path__ + "img/Cycling-BMX-Racing.a7899fa6.png";